import { COMMON_SET_AGREEMENT_LINK, COMMON_RESET } from "./actionTypes";

export const initialCommonState = {
  agreementLink: null,
};

const common = (state = initialCommonState, action) => {
  switch (action.type) {
    case COMMON_SET_AGREEMENT_LINK:
      return { ...state, agreementLink: action.payload };
    case COMMON_RESET:
      return { ...initialCommonState };
    default:
      return state;
  }
};

export default common;
